import { BoxProps, HStack, Skeleton, Stack, Text, TextProps, useColorModeValue } from "@chakra-ui/react";
import CopyButton from "components/Button/Copy";
import Icon, { IconNames } from "components/Icon/Icon";
import { useCopy } from "hooks";
import { ReactNode } from "react";

export interface DetailItemProps extends BoxProps {
  icon?: IconNames;
  title: string;
  description: ReactNode;
  moreDescription?: string;
  isLoading?: boolean;
  _title?: TextProps;
  _description?: TextProps;
  isCopyable?: boolean;
}

export default function DetailItem(props: DetailItemProps) {
  const { icon, title, moreDescription, description, isLoading, isCopyable = false, _title, _description, ...xprops } = props;

  const { onCopy } = useCopy(description as any);

  //  const isComponent = useMemo(() => typeof description !== "string", [description]);

  const color = useColorModeValue("primary.default", "secondary.500");
  const borderColor = useColorModeValue("border", "dark.border");

  return (
    <Stack w="100%" p="20px 4px" borderBottom="1px solid transparent" borderBottomColor={borderColor} {...xprops}>
      <Skeleton
        isLoaded={!isLoading ? true : false}
        w="fit-content"
        mb={isLoading ? "2px" : 0}
        maxH={isLoading ? "12px" : "fit-content"}
      >
        <Text fontSize="14px" color="grey.400" fontWeight="500" {..._title}>
          {title}
        </Text>
      </Skeleton>

      <HStack justifyContent="space-between" w="100%">
        <Skeleton
          isLoaded={!isLoading ? true : false}
          w="fit-content"
          mb={isLoading ? "2px" : 0}
          maxH={isLoading ? "12px" : "fit-content"}
        >
          <HStack>
            {icon && <Icon type={icon} />}
            <Text color={color} fontWeight="600" mt="0 !important" {..._description}>
              {moreDescription ?? description}
            </Text>
          </HStack>
        </Skeleton>

        {isCopyable && (
          <Skeleton
            isLoaded={!isLoading ? true : false}
            w="fit-content"
            // mb={isLoading ? "2px" : 0}
            maxH={isLoading ? "12px" : "fit-content"}
          >
            <CopyButton onClick={onCopy} />
          </Skeleton>
        )}
      </HStack>
    </Stack>
  );
}
